const PortalBaseURL = process.env.BASE_URL;
const dev = {
  PortalBaseURL,
  PortalBrowserBaseURL: '/portal',
  businessBrowserUrl: 'http://localhost:8003',
  bidBrowserUrl: 'http://localhost:8200',
  baseImgUrl: 'http://jwt.com:9083/',
  chatUrl: '//172.18.61.56:8081',
  // bcsBrowserUrl: '//http://jwt.com:8082',
  bcsBrowserUrl: '//http://localhost:8003',
  proxy: {
    '/portal': {
      // target: PortalBaseURL,
      target: 'https://www.jstec.com.cn/portal',
      // target: 'http://jwt.com:8081/portal',
      // target: PortalBaseURL,
      // target: 'https://www.jstec.com.cn/portal',
      cookieDomainRewrite: 'localhost',
      changeOrigin: true, // 允许跨域
      ws: true, // 启用WebSocket代理(对SSE很重要)
      pathRewrite: {
        '^/portal': '', // 重写路径，移除/api前缀
      },
    },
    '/file': {
      target: PortalBaseURL,
    },
  },
};

export default dev;
